import React, { useState } from 'react';
import styled from 'styled-components';
import { Row } from 'styled/alignment/Row';
import colors from 'theme/colors';
import { useUser } from 'context/user/User';
import useToast from 'hooks/useToast';
import ToastContainer from 'components/_UI/ToastsContainer';
import EstablishmentEventSelector from './EstablishmentEventSelector';
import EstablishmentOrderFilters from './EstablishmentOrderFilters';
import EstablishmentOrdersTable from './EstablishmentOrdersTable';

export default function EstablishmentOrders() {
    const tabs = [
        { name: 'all', label: 'Todos' },
        { name: 'requested', label: 'Solicitado' },
        { name: 'preparing', label: 'Preparando' },
        { name: 'ready_for_pickup', label: 'Pronto para retirada' },
        { name: 'picked_up', label: 'Retirado' },
        { name: 'refunded', label: 'Estornado' },
    ];

    const { user } = useUser();
    const { toasts, toast } = useToast();
    const [selectedTab, setSelectedTab] = useState('all');
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [filters, setFilters] = useState({
        search: '',
    });

    const onEventSelected = (event) => {
        setSelectedEvent(event);
    };

    const onUpdateFilter = (filters) => {
        setFilters({
            search: filters.search,
        });
    };

    return (
        <>
            <ToastContainer toasts={toasts} />

            <Tabs>
                {tabs.map(tab => (
                    <TabItem
                        key={tab.name}
                        selected={tab.name === selectedTab}
                        onClick={() => setSelectedTab(tab.name)}
                    >
                        {tab.label}
                    </TabItem>
                ))}
            </Tabs>

            <Row gap="1rem">
                <EventSelector>
                    <EstablishmentEventSelector
                        establishment={user?.establishments[0]}
                        onEventSelected={onEventSelected}
                    />
                </EventSelector>

                <FiltersContainer>
                    <EstablishmentOrderFilters
                        onUpdateFilter={onUpdateFilter}
                    />
                </FiltersContainer>
            </Row>

            <EstablishmentOrdersTable
                status={selectedTab}
                activeEvent={selectedEvent}
                filters={filters}
                toast={toast}
            />
        </>
    );
}

const Tabs = styled(Row)`
    border-bottom: 1px solid ${colors.night};
    margin-top: 20px;
`;

const TabItem = styled.div`
    padding: 8px 14px;
    cursor: pointer;
    transition: border-bottom 0.2s ease-in-out;

    &:first-child {
        padding-left: 10px;
    }

    ${({ selected }) => selected && `
        border-bottom: 3px solid ${colors.occasionalPurple};
        font-weight: bold;
    `};
`;

const EventSelector = styled.div`
    margin-top: 20px;
    max-width: 300px;
`;

const FiltersContainer = styled.div`
    margin-top: 20px;
    max-width: 500px;
`